import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsPhotoExportStudentParm } from "./wsPhotoExportStudentParm";
import { wsPhotoExportStaffParm } from "./wsPhotoExportStaffParm";
import { wsExportMapFileRequest } from "./wsExportMapFileRequest";

@Injectable()
export class DataService_photoexport {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	StudentGroupsSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	StudentGroupsSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "PhotoID/StudentGroupsSelectList";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoExportStudent
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoExportStudent(parms: wsPhotoExportStudentParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoExportStudent";

		var promise$ = this.httpclientService.postBlob(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoExportStaff
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoExportStaff(parms: wsPhotoExportStaffParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoExportStaff";

		var promise$ = this.httpclientService.postBlob(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoExportPreferencesSelect
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoExportPreferencesSelect(SchoolID) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoExportPreferencesSelect?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoExportResetDonwloadRequests
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoExportResetDonwloadRequests(SchoolID) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoExportResetDonwloadRequests?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoExportDownloadMapFile
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoExportDownloadMapFile(parms: wsExportMapFileRequest) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoExportDownloadMapFile?";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
